import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import { getSkills } from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const SkillsModalPageController = () => {
  const state = useProfileState();
  const { onResponse, onError } = useProfileActions();

  return (
    <PageController
      pageNumber={state.skillsModal?.pageNumber}
      numberOfPages={state.skillsModal?.numberOfPages}
      goToFirstPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: 1,
          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
          skillName: state?.skillsModal?.newUnrecognizedSkillForm?.skillName,
        });
      }}
      goToPreviousPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: (state.skillsModal?.pageNumber - 1),
          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
          skillName: state?.skillsModal?.newUnrecognizedSkillForm?.skillName,
        });
      }}
      goToNextPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: (state.skillsModal?.pageNumber + 1),
          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
          skillName: state?.skillsModal?.newUnrecognizedSkillForm?.skillName,
        });
      }}
      goToLastPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: state.skillsModal?.numberOfPages,
          debouncedSkillNameForFuzzyFilter: state?.skillsModal?.newUnrecognizedSkillForm?.debouncedSkillNameForFuzzyFilter,
          skillName: state?.skillsModal?.newUnrecognizedSkillForm?.skillName,
        });
      }}
    />
  );
};

export default SkillsModalPageController;
